import { useRouter } from "next/navigation";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Order from "@/redux/models/Order";
import { addToCart } from "@/services/OrderService";
import LoadingSpinner from "../LoadingSpinner";

export const AddToCartButton = ({ order }) => {
  const currentOrder = useSelector(Order.selectors.getOrder);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();

  const onClick = () => {
    setLoading(true);
    addToCart(currentOrder?.id, order.id)
      .then((res) => {
        if (currentOrder?.id) {
          dispatch(Order.types.updateOrder(res));
        } else {
          dispatch(Order.types.create(res));
        }
        toast.success("Items added to your cart");
        router.push(`/cart/${res.id}`);
      })
      .catch((err) => toast.error(err?.message || "Something went wrong!"))
      .finally(() => setLoading(false));
  };
  return (
    <button
      className="text-xs py-2 outline-gray-400 hover:bg-gray-100 flex gap-2 justify-center"
      onClick={onClick}
      disabled={loading}
    >
      Add To Cart
      {loading && <LoadingSpinner className="w-4 h-4 text-blue-500" />}
    </button>
  );
};
